// apps/web/src/api/userData.ts
// 错题本 / 收藏 / 笔记 — API 调用

import api from "./client";
import type { WrongQuestionDTO, FavoriteDTO, NoteDTO } from "@examfast/shared-types";

// NOTE: api client already prefixes /api/v1, so BASE is empty
const BASE = "";

function buildQuery(opts: Record<string, string | number | undefined>): string {
  const params = new URLSearchParams();
  for (const [key, val] of Object.entries(opts)) {
    if (val !== undefined && val !== null) params.set(key, String(val));
  }
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

// ========== 错题本 ==========

export async function listWrongApi(opts: {
  page?: number;
  page_size?: number;
  bank_id?: string;
} = {}): Promise<{ items: WrongQuestionDTO[]; total: number }> {
  return api.get(`wrong${buildQuery(opts)}`);
}

export async function removeWrongApi(questionId: string): Promise<void> {
  return api.del(`wrong/${questionId}`);
}

export async function clearWrongApi(opts: { bank_id?: string } = {}): Promise<void> {
  return api.del(`wrong${buildQuery(opts)}`);
}

export async function toggleMasteredApi(questionId: string): Promise<{ mastered: boolean }> {
  return api.post(`wrong/${questionId}/mastered`, {});
}

// ========== 收藏 ==========

export async function listFavoritesApi(opts: {
  page?: number;
  page_size?: number;
  bank_id?: string;
} = {}): Promise<{ items: FavoriteDTO[]; total: number }> {
  return api.get(`favorites${buildQuery(opts)}`);
}

export async function addFavoriteApi(questionId: string): Promise<void> {
  return api.post(`favorites`, { question_id: questionId });
}

export async function removeFavoriteApi(questionId: string): Promise<void> {
  return api.del(`favorites/${questionId}`);
}

// ========== 笔记 ==========

export async function listNotesApi(opts: {
  page?: number;
  page_size?: number;
  bank_id?: string;
  question_id?: string;
} = {}): Promise<{ items: NoteDTO[]; total: number }> {
  return api.get(`notes${buildQuery(opts)}`);
}

export async function getNoteApi(noteId: string): Promise<NoteDTO> {
  return api.get(`notes/${noteId}`);
}

export async function createNoteApi(data: {
  bank_id: string;
  question_id?: string;
  content: string;
}): Promise<NoteDTO> {
  return api.post(`notes`, data);
}

export async function updateNoteApi(noteId: string, content: string): Promise<NoteDTO> {
  return api.put(`notes/${noteId}`, { content });
}

export async function deleteNoteApi(noteId: string): Promise<void> {
  return api.del(`notes/${noteId}`);
}
